exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-p[data-v-28c822f4]{font-size:medium}.font-who[data-v-28c822f4]{font-size:large;font-weight:700}.font-data[data-v-28c822f4]{color:var(--ra-color-grey1)!important}", ""]);

// exports
